import {
    Person,
    School,
    Search,
    StarBorder,
    TrendingUp,
    Work,
} from '@mui/icons-material'
import { type FilterTab } from 'recruiter/components/FiltersDrawer'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'
import { getCandidateFilterTabMeta } from './candidateFilterTabConfig'
import { ExperienceFilterSection } from './ExperienceFilterSection'
import { RecruitingStatusFilterSection } from './RecruitingStatusFilterSection'
import { CandidateRatingFilterSection } from './CandidateRatingFilterSection'
import { SearchesFilterSection } from './SearchesFilterSection'
import { AttributesFilterSection } from './AttributesFilterSection'
import { EducationFilterSection } from './EducationFilterSection'

const iconSx = { fontSize: '1.125rem' }

export function buildCandidateResearchFilterTabs(
    filters: CandidateFilterState,
    updateFilters: (patch: Partial<CandidateFilterState>) => void
): FilterTab[] {
    const meta = getCandidateFilterTabMeta(filters)

    return [
        {
            icon: <Work sx={iconSx} />,
            label: 'Experience',
            content: (
                <ExperienceFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.experience.hasActive
                ? () => updateFilters(meta.experience.clearValues)
                : undefined,
        },
        {
            icon: <TrendingUp sx={iconSx} />,
            label: 'Recruiting Status and Preferences',
            content: (
                <RecruitingStatusFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.status.hasActive
                ? () => updateFilters(meta.status.clearValues)
                : undefined,
        },
        {
            icon: <StarBorder sx={iconSx} />,
            label: 'Candidate Rating',
            content: (
                <CandidateRatingFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.rating.hasActive
                ? () => updateFilters(meta.rating.clearValues)
                : undefined,
        },
        {
            icon: <Search sx={iconSx} />,
            label: 'Searches',
            content: (
                <SearchesFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.searches.hasActive
                ? () => updateFilters(meta.searches.clearValues)
                : undefined,
        },
        {
            icon: <Person sx={iconSx} />,
            label: 'Attributes',
            content: (
                <AttributesFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.attributes.hasActive
                ? () => updateFilters(meta.attributes.clearValues)
                : undefined,
        },
        {
            icon: <School sx={iconSx} />,
            label: 'Education',
            content: (
                <EducationFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.education.hasActive
                ? () => updateFilters(meta.education.clearValues)
                : undefined,
        },
    ]
}
